import type { ReviewLink } from '@/types';

type DeviceType = 'ios' | 'android' | 'desktop';

const getDeviceType = (): DeviceType => {
  const ua = window.navigator.userAgent;

  if (ua.match(/(iPad)|(iPod)|(iPhone)|(Blackberry)/)) {
    return 'ios';
  } else if (ua.match(/(WindowsMobile)|(Android)/)) {
    return 'android';
  } else {
    return 'desktop';
  }
};

function tripadvisor(reviewLink: ReviewLink): string {
  const deviceType = getDeviceType();
  const { profile_url } = reviewLink;

  if (deviceType === 'desktop' || !profile_url) {
    return profile_url || 'https://www.tripadvisor.com';
  }

  const idMatch = profile_url.match(/-d(\w+)-/);
  return idMatch
    ? `https://www.tripadvisor.com/WidgetEmbed-collectreview?partnerId=ReviewCollect&locationId=${idMatch[1]}&lang=en_US&display=true&allowMobile`
    : 'https://www.tripadvisor.com';
}

function google(reviewLink: ReviewLink): string {
  const { place_id } = reviewLink;

  if (!place_id) {
    return 'https://www.google.com/search?q=google+reviews';
  }

  return `https://search.google.com/local/writereview?placeid=${place_id}`;
}

function facebook(reviewLink: ReviewLink): string {
  const deviceType = getDeviceType();
  const { page_id } = reviewLink;

  if (!page_id) {
    return 'https://www.facebook.com';
  }

  if (deviceType === 'ios') {
    return `fb://page/?id=${page_id}&tab=reviews`;
  } else if (deviceType === 'android') {
    return `fb://page/${page_id}`;
  } else {
    return `https://www.facebook.com/pg/${page_id}/reviews/?ref=page_internal`;
  }
}

function yelp(reviewLink: ReviewLink): string {
  const { cid } = reviewLink;
  return cid || 'https://www.yelp.com';
}

function custom(reviewLink: ReviewLink): string {
  // For custom providers, always use the review_submit_url or profile_url
  return reviewLink.review_submit_url || reviewLink.profile_url || '#';
}

type UrlCreator = (reviewLink: ReviewLink) => string;

const urlCreators: Record<string, UrlCreator> = {
  tripadvisor,
  google,
  facebook,
  yelp,
  custom,
};

export const getUrl = (
  providerSlug: string,
  reviewLink: ReviewLink
): string => {
  const creator = urlCreators[providerSlug];

  if (!creator) {
    console.warn(`Unknown provider slug: ${providerSlug}`);
    return '#';
  }

  return creator(reviewLink);
};
